import React, { Component } from 'react';
import $ from 'jquery'

class ProdejInstalaceHWSW extends Component {
    componentDidMount(){


        function resetMenu(){
            $("#home a").removeClass("active");

            $("#sluzby-a-produkty-link").removeClass("active");
            $("#prodej-instalace-li").removeClass("active");
            $("#lokalni-li").removeClass("active");
            $("#outsourcing-li").removeClass("active");
            $("#audit-is-li").removeClass("active");
            $("#webhosting-li").removeClass("active");
            $("#webdesign-li").removeClass("active");
            $("#cenik-praci-li").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();


        $("#prodej-instalace-li").addClass("active");
        $("#basic-nav-dropdown").addClass("active");


    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="prodej-instalace">
            <h1>Prodej, instalace a servis HW a SW</h1>

            <span>
                <h2><b>Prodej  hardware a software:</b></h2>

                Na základě Vašich potřeb nakonfigurujeme odpovídající <b>počítačovou sestavu</b>, která bude vyhovovat Vašim požadavkům i peněžence. Výhoda sestaveného PC na míru je v tom, že při reklamaci nepřijdete o svůj PC či NB na měsíc jako je to zvykem všude jinde, ale jen na dobu nezbytně nutnou.
<br/><br/>
                Chcete si pořídit <b>notebook</b> a nevíte si rady? Máte nějakou představu či jasné požadavky, co má všechno zvládat. Poraďte se s námi, pomůžeme Vám vybrat si za nejlepší cenu nejvhodnější typ pro Vás.
<br/><br/>
                Pro naše zákazníky nabízíme široký sortiment <b>tiskového zařízení</b> a jeho následný servis, opravy a profylaxi (čištění) laserových, inkoustových i jehličkových tiskáren všech značek. Vybereme pro Vás či Vaši firmu kvalitní, ale zároveň ekonomicky výhodné řešení Vašich tisků a kopií.
<br/><br/>
                Nabízíme <b>software</b> podle přání zákazníka, následnou instalaci a konfiguraci dle přání zákazníka. Ke všem nově zakoupeným sestavám a notebookům dodáváme základní software. Na vyžádání zákazníka instalujeme do PC již legálně zakoupený software.
 <br/> <br/><br/>

                <h2><b>Servis počítačů a notebooků:</b></h2>

                Naše firma Vám nabízí kompletní servis Vašeho počítače, notebooku či tiskárny na profesionální úrovni, a to nejem pro domácnosti, ale i pro malé a střední podniky. Každý počítač čas od času potřebuje vyčistit, odvirovat a v tom nejhorším případě reinstalovat. Po převzetí Vašeho počítače či notebooku automaticky provedeme:
               <br/>

                   <li>zálohu veškerých dat</li>
                   <li>diagnostiku pevných části počítače (hardware), abychom vyloučili tento typ chyby a ujistili se, že reinstalace systému či odvirování vyřeší veškeré problémy</li>
                   <li>po reinstalování počítače obnovíme zálohovaná data a programy, které jste měli zprovozněny, pokud nevyžadují licenční kódy či instalační CD (jsou-li nám dodány, provedeme instalaci i těchto programů).</li>

 <br/> <br/>

                <h2><b>Dále Vám nabízíme: </b></h2>
                <li>Konfigurace systémů, instalace nových produktů ,upgrady, patche apod.</li>
               <li>Administrace sítí  - kompletní instalace a správa serverů</li>
                <li>Nastavení a zprovoznění LAN</li>
                <li>Sdílení datových oblastí</li>
               <li>Sdílení souborů, tiskáren a jiných periférií</li>
               <li>Nastavení e-mailových klientů, nastavení prohlížečů …</li>
                <li>Instalace kabeláže – lišty, kabely, zásuvky i telefonní rozvody</li>
                <li>Antivirové zabezpečení - konfigurace a instalace antivirových programů, řešení proti spamu.</li>
                <li>Odvirování jednotlivých pracovních stanic i celých sítí</li>
                <li>Odstraníme škodlivý SW (tzv. spyware)</li>
                <li>Zabezpečení osobních i firemních dat</li>
                <li>Připojení sítí i jednotlivých PC k internetu + zaškolení uživatelů</li>
                <li>Zálohování systémového disku pro případ pozdějšího poškození (destrukce dat, chybou aplikací a virů)</li>
                <li>Zálohování dat a jejich archivace, automatizované zálohování dat</li>
                <li>Obnovy poškozených dat</li>
                <li>Záruční i pozáruční servis výpočetní techniky</li>
                <li>Opravy a přestavby PC, zajistíme opravy notebooků a dalších periferií</li>
            </span>

        </div>


</div>
    );
  }
}

export default ProdejInstalaceHWSW;



// WEBPACK FOOTER //
// ./src/sluzby-a-produkty/ProdejInstalaceHWSW.js